import React from 'react';

// Animated gradient + pattern + rotating background logo. Rendered as a
// fixed backdrop behind all content. Uses backgroundImage (not the
// `background` shorthand) so the CSS-defined background-size (400% 400%)
// survives and the keyframes have somewhere to travel.
function BackgroundLayer({
  animationClassName,
  patternClassName,
  selectedGradientCss,
  animationOpacity,
  patternOpacity,
  logoSrc,
  disableBackgroundEffects,
}) {
  // Performance escape hatch (admin toggle). Renders a flat solid backdrop
  // — no animated gradient, no pattern keyframes, no spinning logo —
  // for low-power or remote-desktop sessions where these layers cause lag.
  if (disableBackgroundEffects) {
    return (
      <div
        className="fixed inset-0 pointer-events-none"
        style={{ backgroundColor: '#314e4a' }}
      />
    );
  }
  // Wrappers are `fixed` (viewport-anchored) rather than `absolute` so the
  // animated gradient's pixel dimensions don't change when page content
  // grows or shrinks (e.g. opening a service info card). With `absolute`
  // the keyframes' `background-position` maps onto a moving target, which
  // made the gradient visibly snap on every service/practitioner change.
  return (
    <>
      <div className="fixed inset-0 pointer-events-none">
        <div
          className={`absolute inset-0 ${animationClassName}`}
          style={{ backgroundImage: selectedGradientCss, opacity: animationOpacity }}
        />
        <div
          className={`absolute inset-0 ${patternClassName}`}
          style={{ opacity: patternOpacity }}
        />
      </div>
      <div className="fixed inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <img
          src={logoSrc}
          alt="Background Decoration"
          className="w-[120vmin] h-[120vmin] opacity-10 animate-spin-slow filter blur-sm"
        />
      </div>
    </>
  );
}

export default React.memo(BackgroundLayer);
